var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImgAllBookMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4716 5.19552C11.6878 4.75758 12.3122 4.75758 12.5284 5.19551L14.4123 9.012C14.498 9.18575 14.6637 9.30623 14.8555 9.33426L19.0692 9.95016C19.5524 10.0208 19.7449 10.6147 19.3951 10.9554L16.347 13.9242C16.208 14.0596 16.1446 14.2548 16.1774 14.446L16.8966 18.6395C16.9792 19.1209 16.4739 19.488 16.0415 19.2607L12.2743 17.2795C12.1026 17.1892 11.8974 17.1892 11.7257 17.2795L7.95846 19.2607C7.52614 19.488 7.0208 19.1209 7.10337 18.6395L7.8226 14.446C7.8554 14.2548 7.79196 14.0596 7.65296 13.9242L4.60487 10.9554C4.25507 10.6147 4.44764 10.0208 4.9308 9.95016L9.14454 9.33426C9.33626 9.30623 9.50196 9.18575 9.58773 9.012L11.4716 5.19552Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImgAllBookMark);
export default __webpack_public_path__ + "static/media/iconImgAllBookMark.0e9a89a023f2b2c128a90c7246416cf7.svg";
export { ForwardRef as ReactComponent };